import { applicationPaths } from '@core/http/applicationPaths';
import { httpClient } from '@core/http/httpClient';
import { EntityReducers } from '@core/store/EntityReducers';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PMZoneSiteModel } from '@shared/models';
import { AxiosResponse } from 'axios';

const getPMZoneSites = createAsyncThunk(
  `${EntityReducers.pmZoneSites}/getPMZoneSites`,
  async ({ accountId }: { accountId: string }) => {
    const response: AxiosResponse<PMZoneSiteModel[]> = await httpClient.get(applicationPaths.sites.getPMZoneSites, {
      params: { accountId },
    });

    return response.data;
  }
);

const addSiteToPMZone = createAsyncThunk(
  `${EntityReducers.pmZoneSites}/addSiteToPMZone`,
  async ({ accountId, siteId }: { accountId: number; siteId: number }) => {
    const response: AxiosResponse<PMZoneSiteModel[]> = await httpClient.put(
      applicationPaths.pmZones.addSiteToPMZone({ accountId }),
      { siteId }
    );

    return response.data;
  }
);

const removeSiteFromPMZone = createAsyncThunk(
  `${EntityReducers.pmZoneSites}/removeSiteFromPMZone`,
  async ({ accountId, siteId }: { accountId: number; siteId: number }) => {
    const response: AxiosResponse<PMZoneSiteModel[]> = await httpClient.delete(
      applicationPaths.pmZones.removeSiteFromPMZone({ accountId, siteId })
    );

    return response.data;
  }
);

export const thunks = { getPMZoneSites, addSiteToPMZone, removeSiteFromPMZone };
